import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, PreloadAllModules, RouterModule } from '@angular/router';
import { MarkdownModule } from 'ngx-markdown';
import { FuseModule } from '@fuse';
import { FuseConfigModule } from '@fuse/services/config';
import { FuseMockApiModule } from '@fuse/lib/mock-api';
import { CoreModule } from 'app/core/core.module';
import { appConfig } from 'app/core/config/app.config';
import { mockApiServices } from 'app/mock-api';
import { LayoutModule } from 'app/layout/layout.module';
import { AppComponent } from 'app/app.component';
import { appRoutes } from 'app/app.routing';
import { environment } from '../environments/environment';
import { AlertModule } from './shared/alert/alert.module';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { DatePipe } from '@angular/common';
import { MatChipsModule } from '@angular/material/chips';
import { MatSelectModule } from '@angular/material/select';
import { EditSiteDetailsComponent } from './components/edit-site-details/edit-site-details.component';
import { EditSlaDaysComponent } from './components/edit-sla-days/edit-sla-days.component';
import { EditAutoClosureComponent } from './components/edit-auto-closure/edit-auto-closure.component';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { SelectSiteComponent } from './components/select-site/select-site.component';
import { FormsModule } from '@angular/forms';
import { ViewMoreDetailsComponent } from './components/view-more-details/view-more-details.component';
import { ConfirmMsgComponent } from './components/confirm-msg/confirm-msg/confirm-msg.component';
import { PlazeDetailsComponent } from './components/plaze-details/plaze-details.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TempMaintenancePageComponent } from './modules/auth/temp-maintenance-page/temp-maintenance-page.component';

// import {
//     SocialLoginModule,
//     SocialAuthServiceConfig,
// } from 'angularx-social-login';
// import { GoogleLoginProvider } from 'angularx-social-login';

const routerConfig: ExtraOptions = {
    preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'enabled',
};

@NgModule({
    declarations: [AppComponent, EditSiteDetailsComponent, EditSlaDaysComponent, EditAutoClosureComponent,SelectSiteComponent, ViewMoreDetailsComponent, ConfirmMsgComponent, PlazeDetailsComponent, TempMaintenancePageComponent],
    imports: [
        BrowserModule,
        AlertModule,
        BrowserAnimationsModule,
     RouterModule.forRoot(appRoutes, { useHash: true }),
        // Fuse, FuseConfig & FuseMockAPI
        FuseModule,
        // SocialLoginModule,
        FuseConfigModule.forRoot(appConfig),
        FuseMockApiModule.forRoot(mockApiServices),
        // Core module of your application
        CoreModule,
        NgxDaterangepickerMd.forRoot(),

        // Layout module of your application
        LayoutModule,

        // 3rd party modules that require global configuration via forRoot
        MarkdownModule.forRoot({}),
        MatChipsModule,
        MatSelectModule,
        MatIconModule,
        MatCheckboxModule,
        MatFormFieldModule,
        FormsModule,
        MatTooltipModule
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    providers: [
        DatePipe,
        // {
        //     provide: 'SocialAuthServiceConfig',
        //     useValue: {
        //         autoLogin: false,
        //         providers: [
        //             {
        //                 id: GoogleLoginProvider.PROVIDER_ID,
        //                 provider: new GoogleLoginProvider(
        //                     environment.googleClientId
        //                 ),
        //             },
        //         ],
        //         onError: (err) => {
        //             console.error(err);
        //         },
        //     } as SocialAuthServiceConfig,
        // },
    ],
})
export class AppModule {}
